import { render, staticRenderFns } from "./TiltakListItem.vue?vue&type=template&id=f2067e2c"
import script from "./TiltakListItem.vue?vue&type=script&lang=js"
export * from "./TiltakListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports